import React from 'react'
import { Trans } from '@lingui/macro'
import styles from '../ThumbnailLabel.module.scss'

const LiveLabel = () => {
  return (
    <div className={styles.Live} data-testid="live-thumbnail-label">
      <div className={styles.Dot} />
      <Trans>Live</Trans>
    </div>
  )
}
export default LiveLabel
